import React, { useEffect, useState } from 'react'

import { HouseOwnerHouseFieldFragment } from '@/lib/graphql'

import { useAuth } from './auth/useAuth'
import { HouseContext } from './HouseContext'

export const HouseProvider = ({ children }: { children: React.ReactNode }) => {
  const [house, setHouse] = useState<HouseOwnerHouseFieldFragment | undefined>()
  const { user } = useAuth()

  useEffect(() => {
    if (!house && user?.houses && user.houses.length) {
      setHouse(user.houses[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <HouseContext.Provider
      value={{
        house,
        setHouse,
      }}
    >
      {children}
    </HouseContext.Provider>
  )
}
